import React from 'react';
import useContentSearch from '../../../../hooks/useContentSearch';
import useHighlights from '../../../../hooks/useHighlights';
import useBriefingKeywords from '../../../../hooks/useBriefingKeywords';
import useTextToSpeech from '../../../../hooks/useTextToSpeech';
import { getYouTubeId } from '../../../../utils/contentProcessor';
import { buildArticleTTSContent } from './articleModalContentUtils';
import {
  buildSemanticHighlights,
  getReducedFontSize
} from './articleModalUtils';

const useArticleModalReadingTools = ({
  articleId,
  contentContainerRef,
  fontSize,
  localArticle,
  open
}) => {
  const {
    isSearchOpen,
    searchTerm,
    setSearchTerm,
    totalMatches,
    currentMatch,
    openSearch,
    closeSearch,
    goToNextMatch,
    goToPrevMatch
  } = useContentSearch(contentContainerRef, open);

  const {
    highlights,
    addHighlight,
    removeHighlight
  } = useHighlights(articleId);

  const { keywords: briefingKeywords } = useBriefingKeywords();
  const semanticHighlights = React.useMemo(() => {
    return buildSemanticHighlights(localArticle);
  }, [localArticle]);

  const ttsHook = useTextToSpeech();
  const {
    isSpeaking,
    isPaused,
    toggle: toggleTTS,
    speak: speakTTS,
    stop: stopTTS,
    isSupported: isTTSSupported,
    progress
  } = ttsHook;

  const getTTSContent = () => {
    if (!localArticle) {
      console.log('[TTS Debug] getTTSContent: No localArticle');
      return '';
    }
    return buildArticleTTSContent(localArticle);
  };

  const handleListen = () => {
    speakTTS(getTTSContent());
  };

  const handleToggleSpeech = () => {
    toggleTTS(getTTSContent());
  };

  return {
    addHighlight,
    briefingKeywords,
    closeSearch,
    currentMatch,
    customFontSize: getReducedFontSize(fontSize),
    goToNextMatch,
    goToPrevMatch,
    handleListen,
    handleToggleSpeech,
    highlights,
    isPaused,
    isSearchOpen,
    isSpeaking,
    isTTSSupported,
    openSearch,
    progress,
    rate: ttsHook.rate,
    removeHighlight,
    searchTerm,
    semanticHighlights,
    setSearchTerm,
    stopTTS,
    totalMatches,
    youtubeId: localArticle?.videoId || localArticle?.youtubeId || getYouTubeId(localArticle?.videoUrl || localArticle?.siteUrl),
    onChangeRate: ttsHook.changeRate
  };
};

export default useArticleModalReadingTools;
